/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */
/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */
// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, prepare } from 'yapi-to-typescript';
// @ts-ignore
import request from "../request";
const mockUrl_0_0_0_0 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_0 = "";
const prodUrl_0_0_0_0 = "";
const dataKey_0_0_0_0 = "data";
/**
 * 接口 添加或修改买手人员 的 **请求配置**
 *
 * @分类 旧接口文档/买手组管理
 * @请求头 `POST /erp/PickerGroup/updateOrAddPickerMember`
 */
const postUpdateOrAddPickerMemberRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/PickerGroup/updateOrAddPickerMember",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postUpdateOrAddPickerMember",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 添加或修改买手人员 的 **请求函数**
 *
 * @分类 旧接口文档/买手组管理
 * @请求头 `POST /erp/PickerGroup/updateOrAddPickerMember`
 */
export const postUpdateOrAddPickerMember = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postUpdateOrAddPickerMemberRequestConfig, requestData),
    ...args
  );
};
postUpdateOrAddPickerMember.requestConfig =
  postUpdateOrAddPickerMemberRequestConfig;
/**
 * 接口 获取买手详情 的 **请求配置**
 *
 * @分类 旧接口文档/买手组管理
 * @请求头 `POST /erp/PickerGroup/pickerMemberDetail`
 */
const postPickerMemberDetailRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/PickerGroup/pickerMemberDetail",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postPickerMemberDetail",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 获取买手详情 的 **请求函数**
 *
 * @分类 旧接口文档/买手组管理
 * @请求头 `POST /erp/PickerGroup/pickerMemberDetail`
 */
export const postPickerMemberDetail = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postPickerMemberDetailRequestConfig, requestData),
    ...args
  );
};
postPickerMemberDetail.requestConfig = postPickerMemberDetailRequestConfig;
const mockUrl_0_0_0_1 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_1 = "";
const prodUrl_0_0_0_1 = "";
const dataKey_0_0_0_1 = "data";
/**
 * 接口 新增&编辑 的 **请求配置**
 *
 * @分类 买手API/买手组
 * @请求头 `POST /erp/PickerGroup/updateOrAddPickerGroup`
 */
const postUpdateOrAddPickerGroupRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_1,
  devUrl: devUrl_0_0_0_1,
  prodUrl: prodUrl_0_0_0_1,
  path: "/erp/PickerGroup/updateOrAddPickerGroup",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_1,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postUpdateOrAddPickerGroup",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 新增&编辑 的 **请求函数**
 *
 * @分类 买手API/买手组
 * @请求头 `POST /erp/PickerGroup/updateOrAddPickerGroup`
 */
export const postUpdateOrAddPickerGroup = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postUpdateOrAddPickerGroupRequestConfig, requestData),
    ...args
  );
};
postUpdateOrAddPickerGroup.requestConfig =
  postUpdateOrAddPickerGroupRequestConfig;
/**
 * 接口 买手组分页 的 **请求配置**
 *
 * @分类 买手API/买手组
 * @请求头 `POST /erp/PickerGroup/pickerGroupList`
 */
const postPickerGroupListRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_1,
  devUrl: devUrl_0_0_0_1,
  prodUrl: prodUrl_0_0_0_1,
  path: "/erp/PickerGroup/pickerGroupList",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_1,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postPickerGroupList",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 买手组分页 的 **请求函数**
 *
 * @分类 买手API/买手组
 * @请求头 `POST /erp/PickerGroup/pickerGroupList`
 */
export const postPickerGroupList = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postPickerGroupListRequestConfig, requestData),
    ...args
  );
};
postPickerGroupList.requestConfig = postPickerGroupListRequestConfig;
/**
 * 接口 获取买手详情 的 **请求配置**
 *
 * @分类 买手API/买手组
 * @请求头 `POST /erp/PickerGroup/getPickerGroupDetail`
 */
const postGetPickerGroupDetailRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_1,
  devUrl: devUrl_0_0_0_1,
  prodUrl: prodUrl_0_0_0_1,
  path: "/erp/PickerGroup/getPickerGroupDetail",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_1,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetPickerGroupDetail",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 获取买手详情 的 **请求函数**
 *
 * @分类 买手API/买手组
 * @请求头 `POST /erp/PickerGroup/getPickerGroupDetail`
 */
export const postGetPickerGroupDetail = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postGetPickerGroupDetailRequestConfig, requestData),
    ...args
  );
};
postGetPickerGroupDetail.requestConfig = postGetPickerGroupDetailRequestConfig;
/* prettier-ignore-end */



// WEBPACK FOOTER //
// ./src/openapi/erp/pickerGroup.js